import { TripOutput } from '@allocab/allocab-passenger-shared-types';

import { HelpAnonymousButton } from './HelpAnonymousButton';
import { HelpAuthenticatedButton } from './HelpAuthenticatedButton';
import { constants } from '../../constants';
import useTokenInfo from '../../hooks/useTokenInfo';
import { t } from '../../services/translation/translation';
import { getStepForTrip } from '../../utils/trip';
import { GradientButton } from '../button/GradientButton';
import { Modal, ModalTitle } from '../Modal';

type Props = {
  trip: TripOutput;
  onClose: () => void;
  anonymous: boolean;
};

export const HelpModal = ({ trip, onClose, anonymous }: Props) => {
  const { isCorporate } = useTokenInfo();
  const is1PlusHourBefore = Date.now() + 60 * 60 * 1000 < trip.resume.departureAt;
  const step = getStepForTrip(trip);

  return (
    <Modal onClose={onClose}>
      <ModalTitle title={t('help-details-modal.title')} />
      <div className="space-y-3 mt-5">
        {(step === 'DRIVER_APPROACHING' || step === 'DRIVER_IN_PLACE') && !!trip.driver ? (
          <div className="space-y-3 text-center">
            <div>{t('help-details-modal.call-description')}</div>
            <a href={`tel:${trip.driver.phoneNumber}`}>
              <GradientButton className="w-full space-y-3 mt-2">{t('help-details-modal.call-button')}</GradientButton>
            </a>
          </div>
        ) : null}
        {(step !== 'DONE' && step !== 'CANCELLED') || is1PlusHourBefore ? (
          <div className="space-y-3 text-center">
            <div>{t('help-details-modal.alert-description')}</div>
            {anonymous ? (
              <HelpAnonymousButton trip={trip} onClose={onClose} />
            ) : (
              <HelpAuthenticatedButton trip={trip} onClose={onClose} />
            )}
          </div>
        ) : null}
        <div className="space-y-3 text-center">
          <div>{t('help-details-modal.message-support-description')}</div>
          <GradientButton
            className="w-full"
            onClick={() =>
              (window.location.href = isCorporate
                ? 'mailto:' + constants.emailPro
                : 'mailto:' + constants.emailIndividual)
            }
          >
            {t('help-details-modal.message-support')}
          </GradientButton>
        </div>
      </div>
    </Modal>
  );
};
